<template>
  <div class="container-fluid p-3">
    <div class="row">
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            <h6 class="text-center">
              DATOS PERSONALES DEL PADRE, MADRE O TUTOR
            </h6>
          </div>
          <div class="card-body">
            Nombre Completo:<br />
            {{ persona.per_nombres }} {{ persona.per_primer_apellido }}
            {{ persona.per_segundo_apellido }}
            <hr />
            Tipo de Documento:<br />
            {{ persona.tipo_documento }}
            <hr />
            Número de Documento:<br />
            {{ persona.per_numero_documento }}
            <hr />
            Fecha de Nacimiento:<br />
            {{ persona.per_fecha_nacimiento }}
            <hr />
            Nacionalidad:<br />
            {{ persona.nacionalidad }}
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="card">
          <div class="card-header">
            <h6 class="text-center">
              DECLARACIÓN JURADA DE DOMICILIO PARA MENORES DE EDAD
            </h6>
          </div>
          <div class="col-12 col-md-12">
            <div
              class="alert alert-warning"
              role="alert"
              style="background-color: rgba(248, 214, 43, 0.1);color:#000;"
            >
              <div class="container">
                <b
                  >Ultima declaracion del sr. {{ persona.per_nombres }}
                  {{ persona.per_primer_apellido }}
                  {{ persona.per_segundo_apellido }}</b
                >
                para Menor de edad<br />
                <div class="row">
                  <div class="col-12 col-md-6">
                    <p>
                      <strong>TIPO DOMICILIO: </strong>
                      <span v-if="declaracionPadre.tipo_domicilio === 'HOS'">
                        CENTRO DE HOSPEDAJE</span
                      >
                      <span v-if="declaracionPadre.tipo_domicilio === 'RES'">
                        RESIDENCIA</span
                      >
                    </p>
                    <p>
                      <strong>NOMBRE DOMICILIO:</strong>
                      {{ declaracionPadre.nombre_domicilio }}
                    </p>
                    <p>
                      <strong>NÚMERO DOCUMENTO:</strong>
                      {{ declaracionPadre.nro_documento }}
                    </p>
                    <p>
                      <strong>DIRECCION:</strong>
                      {{ declaracionPadre.direccion }}
                    </p>
                  </div>
                  <div class="col-12 col-md-6">
                    <p>
                      <strong>DEPARTAMENTO: </strong>
                      <span v-if="declaracionPadre.departamento === 'CHD'"
                        >CHUQUISACA</span
                      >
                      <span v-if="declaracionPadre.departamento === 'CBD'"
                        >COCHABAMBA</span
                      >
                      <span v-if="declaracionPadre.departamento === 'SCD'"
                        >SANTA CRUZ</span
                      >
                      <span v-if="declaracionPadre.departamento === 'LPG'"
                        >LA PAZ</span
                      >
                      <span v-if="declaracionPadre.departamento === 'PND'"
                        >PANDO</span
                      >
                      <span v-if="declaracionPadre.departamento === 'ORD'"
                        >ORURO</span
                      >
                      <span v-if="declaracionPadre.departamento === 'TJD'"
                        >TARIJA</span
                      >
                      <span v-if="declaracionPadre.departamento === 'PTD'"
                        >PANDO</span
                      >
                      <span v-if="declaracionPadre.departamento === 'BND'"
                        >BENI</span
                      >
                    </p>
                    <p>
                      <strong>TELEFONO:</strong> {{ declaracionPadre.telefono }}
                    </p>
                    <p>
                      <strong>FECHA INICIO: </strong>
                      {{
                        moment(declaracionPadre.fecha_inicio).format(
                          "DD/MM/YYYY"
                        )
                      }}
                    </p>
                    <p>
                      <strong>FECHA FIN: </strong>
                      {{
                        moment(declaracionPadre.fecha_fin).format("DD/MM/YYYY")
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row form-group">
              <div>
                <div class="col-12 mt-2">
                  <div class="col-12 col-md-12">
                    <div class="row">
                      <div class="col-12 col-md-4">
                        <label
                          >Nombre(s):
                          <span
                            class="text-danger lb-error"
                            v-if="!$v.parentesco.nombres_par.required"
                            >Campo requerido</span
                          ></label
                        >
                        <input
                          class="form-control"
                          placeholder="Ej.: MARIA FERNANDA"
                          :class="{
                            'is-invalid': $v.parentesco.nombres_par.$error,
                          }"
                          v-model="parentesco.nombres_par"
                          @keyup="
                            parentesco.nombres_par = parentesco.nombres_par.toUpperCase()
                          "
                        />
                      </div>
                      <div class="col-12 col-md-4 ">
                        <label for=""
                          >Primer Apellido:
                          <span
                            class="text-danger lb-error"
                            v-if="!$v.parentesco.primer_apellido_par.required"
                            >Campo requerido</span
                          ></label
                        >
                        <input
                          class="form-control"
                          placeholder="Ej.: LOPEZ"
                          :class="{
                            'is-invalid':
                              $v.parentesco.primer_apellido_par.$error,
                          }"
                          v-model="parentesco.primer_apellido_par"
                          @keyup="
                            parentesco.primer_apellido_par = parentesco.primer_apellido_par.toUpperCase()
                          "
                        />
                      </div>
                      <div class="col-12 col-md-4 ">
                        <label for="">Segundo Apellido: </label>
                        <input
                          class="form-control"
                          placeholder="Ej.: LOPEZ"
                          v-model="parentesco.segundo_apellido_par"
                          @keyup="
                            parentesco.segundo_apellido_par = parentesco.segundo_apellido_par.toUpperCase()
                          "
                        />
                      </div>

                      <div class="col-12 col-md-4 ">
                        <label for=""
                          >Tipo Documento:
                          <span
                            class="text-danger lb-error"
                            v-if="!$v.parentesco.tipo_documento_par.required"
                            >Campo requerido</span
                          ></label
                        >
                        <select
                          class="form-control"
                          :class="{
                            'is-invalid':
                              $v.parentesco.tipo_documento_par.$error,
                          }"
                          v-model="parentesco.tipo_documento_par"
                        >
                          <option value="" selected>SELECCIONAR</option>
                          <option
                            v-for="(item, index) in tipoDocumentos"
                            :value="item.codigo"
                            :key="index"
                            >{{ item.nombre }}</option
                          >
                        </select>
                      </div>
                      <div class="col-12 col-md-4">
                        <label for=""
                          >Nro. Documento:
                          <span
                            class="text-danger lb-error"
                            v-if="!$v.parentesco.numero_documento_par.required"
                            >Campo requerido</span
                          ></label
                        >
                        <input
                          class="form-control"
                          placeholder="Ej.: 12345678"
                          :class="{
                            'is-invalid':
                              $v.parentesco.numero_documento_par.$error,
                          }"
                          v-model="parentesco.numero_documento_par"
                          @keyup="
                            parentesco.numero_documento_par = parentesco.numero_documento_par.toUpperCase()
                          "
                        />
                      </div>
                      <div class="col-12 col-md-4">
                        <label for=""
                          >Fecha de Nacimiento:
                          <span
                            class="text-danger lb-error"
                            v-if="!$v.parentesco.fecha_nacimiento_par.required"
                            >Campo requerido</span
                          ></label
                        >
                        <input
                          type="date"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              $v.parentesco.fecha_nacimiento_par.$error,
                          }"
                          v-model="parentesco.fecha_nacimiento_par"
                          :min="fechaMinimo"
                        />
                      </div>
                      <div class="col-12 col-md-4">
                        <label for=""
                          >Nacionalidad:
                          <span
                            class="text-danger lb-error"
                            v-if="!$v.parentesco.nacionalidad_par.required"
                            >Campo requerido</span
                          ></label
                        >
                        <select
                          class="form-control"
                          :class="{
                            'is-invalid': $v.parentesco.nacionalidad_par.$error,
                          }"
                          v-model="parentesco.nacionalidad_par"
                        >
                          <option value="" selected>SELECCIONAR</option>
                          <option
                            v-for="(item, index) in nacionalidades"
                            :value="item.a3_dgm"
                            :key="index"
                            >{{ item.nombre }}</option
                          >
                        </select>
                      </div>
                       <div class="col-md-4">
                    <label>Grado de Parentesco: <span class="text-danger lb-error" v-if="!$v.parentesco.grado.required">Campo requerido</span></label>        
                    <select
                      class="custom-select"
                      v-model="parentesco.grado"
                      :class="{'is-invalid': $v.parentesco.grado.$error}"
                    >
                      <option value="">SELECCIONAR</option>
                      <option value="PADRE">PADRE</option>
                      <option value="MADRE">MADRE</option>
                      <option value="ABUELA">ABUELA</option>
                      <option value="ABUELO">ABUELO</option>
                    </select>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-4"></div>
              <div class="col-sm-12 col-md-4">
                <router-link
                  :to="{ name: 'historialdeclaracion' }"
                  class="btn btn-primary btn-block"
                >
                  <small> Cancelar</small>
                </router-link>
              </div>
              <div class="col-sm-12 col-md-4">
                <button
                  type="button"
                  class="btn btn-success btn-block"
                  @click="procesarDomicilio(parentesco)"
                >
                  <small>Registrar</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required } from "vuelidate/lib/validators";
import { Icon } from "leaflet";
import moment from "moment";
//const numero = helpers.regex("alpha", /^[-+1234567890]*$/);
//const fechaMin = (value) => value.includes(this.fechaMinimo)
//const fechaMin = withParams({type: 'fechaMinimo'}, value => value === 'fechaMinimo')
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import "vue-select/dist/vue-select.css";
export default {
  name: "DeclaracionHijos",
  components: {
    Loading,
  },

  data() {
    return {
      nacionalidades: [],
      tipoDocumentos: [],
      declaracionPadre: {},
      parentesco: {
        nombres_par: "",
        primer_apellido_par: "",
        segundo_apellido_par: "",
        fecha_nacimiento_par: "",
        numero_documento_par: "",
        tipo_documento_par: "",
        nacionalidad_par: "",
        id_persona: 0,
        tipo_domicilio: "HOS",
        nombre_domicilio: "",
        direccion: "",
        telefono: "",
        fecha_inicio: null,
        fecha_fin: null,
        tipo_documento: "",
        nro_documento: "",
        departamento: "LPG",
        latitud: "",
        longitud: "",
        id_empresa: "",
        empresa_persona: 0,
        zoom: "",
        tipo_hospedaje: "",
        grado: "",
      },
      persona: {
        id_persona: 0,
        per_nombres: "",
        per_per_primer_apellido: "",
        per_per_segundo_apellido: "",
        per_fecha_nacimiento: "",
        per_email: "",
        par_tipo_documento: "",
        per_numero_documento: "",
        par_nacionalidad: "",
        tipo_persona: 3,
      },
      selected: "",
      cargando: false,
      submitted: false,
      resultados: [],
      fechaMinimo:''
    };
  },
  methods: {
    async procesarDomicilio(dato) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }
      try {
        dato.tipo_domicilio = this.declaracionPadre.tipo_domicilio;
        dato.nombre_domicilio = this.declaracionPadre.nombre_domicilio;
        dato.direccion = this.declaracionPadre.direccion;
        dato.telefono = this.declaracionPadre.telefono;
        dato.fecha_inicio = this.declaracionPadre.fecha_inicio;
        dato.fecha_fin = this.declaracionPadre.fecha_fin;
        dato.tipo_documento = this.declaracionPadre.tipo_documento;
        dato.nro_documento = this.declaracionPadre.nro_documento;
        dato.departamento = this.declaracionPadre.departamento;
        dato.latitud = this.declaracionPadre.latitud;
        dato.longitud = this.declaracionPadre.longitud;
        dato.id_empresa = this.declaracionPadre.id_empresa;
        dato.empresa_persona = this.declaracionPadre.empresa_persona;
        dato.tipo_hospedaje = this.declaracionPadre.tipo_hospedaje;
        let res = await this.axios.post(`/insertarHijosMenores`, dato);
        if (res.status === 200) {
          this.$swal({
            title: "Información",
            html: "Datos adicionados, en <b>historial de declaración</b>.",
            type: "success",
            confirmButtonText: "Aceptar",
          });
          this.$router.push("historialDeclaracion");
        }
      } catch (error) {
        this.cargando = false;
        console.log(error);
        this.$swal({
          html: "No existen coincidencias",
          type: "info",
          confirmButtonText: "Aceptar",
        });
      }
    },
    async getPersona() {
      try {
        let res = await this.axios.post(`/extranjeroGetData`);
        this.persona = res.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    async getTipoDocumento() {
      try {
        await this.axios
          .get(`/getParametros/DOCUMENTO`)
          .then((response) => {
            this.tipoDocumentos = response.data.contenido;
          })
          .catch((error) => {
            console.log("catch: ", error);
          });
      } catch (error) {
        console.log("catch: ", error);
      }
    },

    async getNacionalidades() {
      let config = { headers: { token: this.token } };
      try {
        await this.axios
          .get(`/parametrosPaises`, config)
          .then((response) => {
            this.nacionalidades = response.data.contenido;
          })
          .catch((error) => {
            console.log("catch: ", error);
          });
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    getDateUltmo(date) {
            return moment(date).format("YYYY-MM-DD");
        },
    async ultimaDeclaracionPadre() {
      try {
        let resultados = await this.axios.get(`/ultimaDeclaracionPadre`);
        this.declaracionPadre = resultados.data.contenido[0];
        if (resultados.data.contenido[0].tipo_domicilio == 'ND') {
          this.$swal({
            title: "Información",
            html:
              "<b>Realice una Declaración</b><br> porfavor",
            type: "info",
            confirmButtonText: "Aceptar",
          })
          .then((result) => {
            if (result.value) {
              this.$router.push("historialdeclaracion");
           }
          });
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
  },
  created() {
    let date = new Date();
    this.fechaMinimo= this.getDateUltmo(date.setMonth(date.getMonth()-216)),
    this.ultimaDeclaracionPadre();
    this.getPersona();
    this.getNacionalidades();
    this.getTipoDocumento();
  },

  validations: {
    parentesco: {
      nombres_par: { required },
      primer_apellido_par: { required },
      fecha_nacimiento_par: { required},
      numero_documento_par: { required },
      tipo_documento_par: { required },
      nacionalidad_par: { required },
      grado: { required },
    },
  },
};
</script>
